import styled from 'styled-components';
import { Container } from '@mui/material';

const ContentWrapper = styled(Container).attrs((props) => ({ maxWidth: 'xl' }))`
  padding: 1rem;
`;

export default ContentWrapper;
